import { render } from "./IcCheck.vue?vue&type=template&id=cb48aad0&scoped=true"
import script from "./IcCheck.vue?vue&type=script&lang=js"
export * from "./IcCheck.vue?vue&type=script&lang=js"

import "./IcCheck.vue?vue&type=style&index=0&id=cb48aad0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb48aad0"]])

export default __exports__